import { useTypedSelector } from '../reducers';

export default function useAuthUser() {
  const user = useTypedSelector((state) => state.auth.user);
  if (!user) {
    throw new Error(
      'useAuthUser should only be called within a navigator which guarantees auth',
    );
  }
  return user;
}
